import { render, staticRenderFns } from "./PartnerCopy.vue?vue&type=template&id=029d3994&"
import script from "./PartnerCopy.vue?vue&type=script&lang=ts&"
export * from "./PartnerCopy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports